import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';
import { TrainingCenter } from 'src/app/@core/routes/user-management.const';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { ProfileModel, TrainingCenterModel } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class TrainingCenterService extends BaseFucntionsService<TrainingCenterModel> {
  constructor(apiClient: ApiClientService) {
    super(ApplicationRoutes.TrainingCenter, apiClient);
  }

  /** Training centres flagged "show in home"; public projection for the home carousel. */
  getHomeTrainingCenters(): Observable<TrainingCenterModel[]> {
    return this.apiClient.get(TrainingCenter.Home);
  }

  getProfileDetails(trainingCenterId: number):Observable<ProfileModel> {
    return this.apiClient.get(TrainingCenter.Profile(trainingCenterId));
  }
}
